import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardBody, Button, Row, Col } from "reactstrap";
import classNames from "classnames";
import { mapToCssModules } from "reactstrap/lib/utils";

const propTypes = {
  header: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  value: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  invert: PropTypes.bool,
  onClick: PropTypes.func,
};

const defaultProps = {
  header: "87.500",
  icon: "icon-people",
  color: "info",
  value: "25",
  children: "Visitors",
  invert: false,
};

class CardInfo extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="card">
        <div className="card-body"></div>
      </div>
    );
  }
}

CardInfo.propTypes = propTypes;
CardInfo.defaultProps = defaultProps;

export default CardInfo;



// WEBPACK FOOTER //
// ./client/react/Admin/components/CardInfo/index.js